import { render, staticRenderFns } from "./LayoutBaseWithCap.vue?vue&type=template&id=58ecff20&scoped=true&"
import script from "./LayoutBaseWithCap.vue?vue&type=script&lang=js&"
export * from "./LayoutBaseWithCap.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBaseWithCap.vue?vue&type=style&index=0&id=58ecff20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ecff20",
  null
  
)

export default component.exports